import { makeAutoObservable, action, observable, computed } from "mobx";

export class AlertModalStore {
  message = "";
  visible = false;

  constructor() {
    makeAutoObservable(this, {
      message: observable,
      visible: observable,
      setVisible: action,
      setMessage: action,
      getVisibility: computed,
      getMessage: computed,
    });
  }

  setVisible(newVisible) {
    this.visible = newVisible;
  }

  setMessage(newMessage) {
    this.message = newMessage;
  }

  get getVisibility() {
    return this.visible;
  }

  get getMessage() {
    return this.message;
  }
}

export default AlertModalStore;
